<template>
  <SelectInput
    :model-value="modelValue"
    :options="QUESTION_TYPES"
    :label="label"
    hide-placeholder
    data-cy="question-type"
    @update:model-value="(v) => emit('update:modelValue', v)"
  >
    <template #selected="{ option }">
      <span class="flex items-center gap-2">
        <i class="fas w-4 text-center" :class="[option.icon, option.color]"></i>
        <span class="text-gray-900">{{ option.label }}</span>
      </span>
    </template>
    <template #option="{ option }">
      <CustomFormTypeOption :option="option" />
    </template>
  </SelectInput>
</template>

<script setup lang="ts">
import SelectInput from "@/components/Seranova/SelectInput/SelectInput.vue";
import { QUESTION_TYPES } from "./customFormFields";
import CustomFormTypeOption from "./CustomFormTypeOption.vue";

withDefaults(defineProps<{ modelValue: string; label?: string }>(), {
  label: ""
});
const emit = defineEmits<{ "update:modelValue": [value: string] }>();
</script>
